import { newAxiosIns } from '@/libs/axios'

export default function apiGetBalance() {
  return newAxiosIns.get('/komchat-api/api/v1/user_balance')
}

export function apiTopupBalance(nominal, method, fee) {
  const params = {
    nominal,
    method,
    fee,
  }
  return newAxiosIns.post('/komchat-api/api/v1/user_balance/topup', { params })
}

export function apiCheckBill() {
  return newAxiosIns.get('xendit/api/v1/xendit/bill/check-bill/komchat')
}

export function apiTopUpWithQris(amount) {
  const params = {
    channel_pay: 'dana',
    description: 'topup using QRIS',
    duration: 1440,
    amount,
  }
  return newAxiosIns.post('xendit/api/v1/xendit/qrcode/create-qrcode/komchat', params)
}

export function apiTopUpWithBankTransfer(amount) {
  const params = {
    description: 'topup using Bank method',
    invoice_duration: 86400,
    amount,
  }
  return newAxiosIns.post('/xendit/api/v1/xendit/invoice/create-invoice/komchat', params)
}

export function apiCancelTopUpInvoice(invoiceId, partner_id) {
  return newAxiosIns.put(`/xendit/api/v1/xendit/invoice/expire-invoice/${invoiceId}?partner_id=${partner_id}`)
}

export function apiCancelTopUpQrcode(qrcodeId, partner_id) {
  return newAxiosIns.put(`/xendit/api/v1/xendit/qrcode/expire-qrcode/${qrcodeId}?partner_id=${partner_id}`)
}

export function apiIdealBalance(id) {
  return newAxiosIns.get(`komship/api/v1/admin/partner-consumables/balance-analitycs/${id}`)
}

export function apiGetBalanceHistory(params) {
  return newAxiosIns.get('/komchat-api/api/v1/user_balance/detail', { params })
}
